<template>
    <div>
        <PagesContent tab="13" sub="1313"></PagesContent>
    </div>
</template>

<script setup lang="ts">
import langObj from "@/utils/lang";
var lng: any = langObj['zh']
useSeoMeta({
    title: lng['力士达集团'],
    description: '力士达集团',
    keywords: '力士达, lsd',
});
</script>